<template>
  <el-tag :type="type">{{ status }}</el-tag>
</template>

<script setup lang="ts">
import { ComputedRef, computed, defineProps } from "vue";
import { ExperimentStatus } from "@/shared/types/experiments";

const props = defineProps<{ status: ExperimentStatus }>();

const tagTypes = {
  [ExperimentStatus.Draft]: "info",
  [ExperimentStatus.Active]: "success",
  [ExperimentStatus.Stopped]: "danger",
};

const type: ComputedRef<string> = computed(() => tagTypes[props.status]);
</script>
